var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PostitOnContent"},[_c('div',{staticClass:"wrapper",style:({'height': `${_vm.height}px`})},[_c('div',{staticClass:"content"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"postit"},[_vm._t("postit")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }